if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();

        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.isBundle = this.dataset.isBundle === "true";
        this.updateSetPrice();
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
        if (window.screen.height < 668) {
          this.style.height = "auto";
        }
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener
          .querySelector(".loading-overlay__spinner")
          .classList.remove("hidden");

        if(this.isBundle) {
          fetch(`${opener.getAttribute("data-product-url")}`)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            );
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.preventVariantURLSwitching();
            if (this.isBundle) {
              this.selectCartProducts();
            }
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener
              .querySelector(".loading-overlay__spinner")
              .classList.add("hidden");
          });
        } else {
          const baseUrl = opener.getAttribute("data-product-url");
          const qa_url = new URL(baseUrl, window.location.origin);

          qa_url.searchParams.set("view", "quick-add-content");

          fetch(qa_url.href)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.productElement = responseHTML.querySelector(
              '.quick-add-modal__content-wrapper'
            );

            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            this.removeGalleryListSemantic();
            this.preventVariantURLSwitching();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener
              .querySelector(".loading-overlay__spinner")
              .classList.add("hidden");
          });
        }

      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector(
          "variant-radios,variant-selects"
        );
        if (!variantPicker) return;

        variantPicker.setAttribute("data-update-url", "false");
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector(
          "pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const modalDialog =
          this.productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        this.productElement
          .querySelector(".vbb-set__details__sticky")
          ?.remove();
        this.productElement
          .querySelector(".vbb-set__details__description")
          ?.remove();
        this.productElement.querySelector(".vbb-set__carousel")?.remove();
        this.productElement
          .querySelector(".sticky-back-top__wrapper")
          ?.remove();
        this.productElement
          .querySelector(".vbb-product-details__details-container--mobile")
          ?.remove();
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios")
          .forEach((variantSelect) => {
            variantSelect.dataset.originalSection = sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      selectCartProducts() {
        this.cartJson =
          JSON.parse(
            document.querySelector("script#cart-upsell-json")?.innerText
          ) ?? null;

        if (!this.cartJson) return; // Ensure productElement exists
        const bundleFormItems = this.querySelectorAll(
          ".vbb-set__details__item"
        );
        bundleFormItems.forEach((bundleFormItem, index) => {
          const productInCart = this.cartJson.items.findIndex(
            (item) =>
              item.product_id == bundleFormItem.dataset.activeProductId &&
              item.quantity > 0
          );
          if (productInCart > -1) {
            this.cartJson.items[productInCart].quantity -= 1;
            if (bundleFormItem.dataset.hasOnlyDefaultVariant === "true") {
              bundleFormItem
                .querySelector(".vbb-set__details__item--button")
                .click();
            } else {
              let item = bundleFormItems[index].querySelector(
                `li[data-variant-id="${this.cartJson.items[productInCart].variant_id}"]`
              );
              if (item) {
                item.click();
              }
            }
          }
        });
        const button = this.querySelector(
          ".vbb-set__details__atc button span:last-of-type"
        );
        if (button) {
          button.innerText = " - complete the bundle";
        }
      }

      async updateSetPrice() {
        const response = await fetch(this.getAttribute("data-product-url"));
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const vbbSetForm = html.querySelector("vbb-set-form");
        const { hasVariablePrice, customBundle, currencySymbol } =
          vbbSetForm.dataset;
        const isCustomBundle = customBundle === "true";
        const spinnerId = this.dataset.spinner;
        let discountedPrice, preDiscountedPrice;

        if (isCustomBundle) {
          const minimumItems = vbbSetForm.querySelector("[data-minimum-items]")
            .dataset.minimumItems;
          const items = Array.from(
            html.querySelectorAll("vbb-set-form .vbb-set__details__item")
          );
          const itemPrices = items.map((item) =>
            parseFloat(item.dataset.price)
          );
          const itemDiscountedPrices = items.map((item) =>
            parseFloat(item.dataset.discountedPrice)
          );

          preDiscountedPrice = this.calculateTotalPrice(itemPrices);
          discountedPrice = this.calculateTotalPrice(
            itemDiscountedPrices,
            minimumItems
          );
        } else {
          discountedPrice = html.querySelector(
            ".vbb-set__details__price--discounted"
          ).innerText;
          preDiscountedPrice = html.querySelector(
            ".vbb-set__details__price--prediscounted"
          )?.innerText;
        }

        this.updatePriceElements(spinnerId, {
          discountedPrice,
          preDiscountedPrice,
          currencySymbol,
          hasVariablePrice,
          isCustomBundle,
        });
      }

      calculateTotalPrice(prices, limit = prices.length) {
        return prices
          .sort()
          .slice(0, limit)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
          .toFixed(2);
      }

      updatePriceElements(
        id,
        {
          discountedPrice,
          preDiscountedPrice,
          currencySymbol,
          hasVariablePrice,
          isCustomBundle,
        }
      ) {
        const priceHtml = `
        <div class="price price--sold-out price--on-sale">
          <div class="price__container">
            <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">Sale price</span>
              <span class="price-item price-item--sale price-item--last">${
                hasVariablePrice || isCustomBundle ? "From " : ""
              }${isCustomBundle ? currencySymbol : ""}${discountedPrice}</span>
              ${
                preDiscountedPrice != null
                  ? `<span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <span><s class="price-item price-item--regular">${
                      isCustomBundle ? currencySymbol : ""
                    }${preDiscountedPrice}</s></span>`
                  : ""
              }
            </div>
          </div>
        </div>
      `;

        document
          .querySelectorAll(`#${id} .bundle-upsell-price__placeholder`)
          .forEach((el) => (el.innerHTML = priceHtml));
      }
    }
  );
}
